import { useState, useEffect, useRef } from "react";

import { PageLoading } from "common/ui/PageLoading";

import { useRouteChange } from "common/middleware/hooks";

import styles from "./PageTransitionSpinner.module.scss";

const PageTransitionSpinner = () => {
  const { routeChanging } = useRouteChange();
  const [showSpinner, setShowSpinner] = useState(false);

  const timer = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (routeChanging) {
      timer.current = setTimeout(() => setShowSpinner(true), 500);
    } else {
      clearTimeout(timer.current);
      setShowSpinner(false);
    }

    return () => {
      clearTimeout(timer.current);
      setShowSpinner(false);
    };
  }, [routeChanging]);

  if (!showSpinner) {
    return null;
  }

  return (
    <div className={styles.PageTransitionSpinner}>
      <PageLoading />
    </div>
  );
}

export { PageTransitionSpinner };
